var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-select',{staticStyle:{"margin-top":"5px","margin-bottom":"5px"},attrs:{"placeholder":"Select From Tank","options":_vm.tanks},on:{"search:blur":_vm.selectedTank},model:{value:(_vm.tank),callback:function ($$v) {_vm.tank=$$v},expression:"tank"}})
}
var staticRenderFns = []

export { render, staticRenderFns }